<template>
  <div>
    <BlogContent/>
  </div>
</template>

<script>
import BlogContent from "@/components/blog/BlogContent";
export default {
  name: "ClemBlog",
  components: {BlogContent},
  //此路由激活时
  activated() {
    // 添加高亮
    this.$store.commit('updateBlogColor','#000000');
    //定位到顶部
    window.scroll(0, 0);
  },
  // 删除高亮
  deactivated() {
    this.$store.commit('updateBlogColor','');
  }
}
</script>

<style scoped>

</style>
